import { TUser } from './../../models/index'
import { IAuthState } from './types'
import {
  signUpThunk,
  signInThunk,
  googleAuthThunk,
  appleAuthThunk,
  refreshTokenThunk,
  getMeThunk,
  forgotPasswordThunk,
  checkTokenToUpdatePasswordThunk,
  updatePasswordThunk,
  logOutThunk,
  updateUserThunk
} from './thunks'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import Roles from '../../models/roles'

const initialState: IAuthState = {
  inProgress: false,
  user: null,
  error: ''
}

const usersSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUserAction: (state, action: PayloadAction<TUser>) => {
      state.user = action.payload
    },
    setUserRoleAction: (state, action: PayloadAction<Roles>) => {
      // TODO change whole all project agency_role to current_project_role
      if (state.user) {
        state.user = {
          ...state.user,
          agency_role: action.payload
        }
      }
    },
    setTokenAction: (state, action: any) => {
      const tokenData = {
        token: action.payload.access_token,
        expire_at: new Date().getTime() + action.payload.expires_in * 1000
      }

      localStorage.setItem('token', JSON.stringify(tokenData))
    },
    resetAuthErrorAction: (state) => {
      state.error = null
    },
    appLogOutAction: (state) => {
      state.user = null
      localStorage.removeItem('token');
      localStorage.removeItem('startEndDates');
    }
  },
  // Async actions
  extraReducers: (builder) => {
    // signUp
    builder.addCase(signUpThunk.pending, (state, action) => {
      state.inProgress = true
      state.error = null
    })
    builder.addCase(signUpThunk.fulfilled, (state, action) => {
      state.inProgress = false
    })
    builder.addCase(signUpThunk.rejected, (state, action) => {
      state.inProgress = false
      state.error = action.payload
    })
    // signIn
    builder.addCase(signInThunk.pending, (state, action) => {
      state.inProgress = true
      state.error = null
    })
    builder.addCase(signInThunk.fulfilled, (state, action) => {
      state.inProgress = false
    })
    builder.addCase(signInThunk.rejected, (state, action) => {
      state.inProgress = false
      state.error = action.payload
    })
    // update user data
    builder.addCase(updateUserThunk.pending, (state, action) => {
      state.inProgress = true
    })
    builder.addCase(updateUserThunk.fulfilled, (state, action: PayloadAction<TUser>) => {
      state.inProgress = false
      state.user = { ...state.user, ...action.payload }
    })
    builder.addCase(updateUserThunk.rejected, (state, action) => {
      state.inProgress = false
    })
    // refreshToken
    builder.addCase(refreshTokenThunk.pending, (state, action) => {
      state.inProgress = true
      state.error = null
    })
    builder.addCase(refreshTokenThunk.fulfilled, (state, action) => {
      state.inProgress = false
    })
    builder.addCase(refreshTokenThunk.rejected, (state, action) => {
      state.inProgress = false
    })
    // googleAuth
    builder.addCase(googleAuthThunk.pending, (state, action) => {
      state.inProgress = true
      state.error = null
    })
    builder.addCase(googleAuthThunk.fulfilled, (state, action) => {
      state.inProgress = false
    })
    builder.addCase(googleAuthThunk.rejected, (state, action) => {
      state.inProgress = false
    })
    //appleAuth
    builder.addCase(appleAuthThunk.pending, (state, action) => {
      state.inProgress = true
      state.error = null
    })
    builder.addCase(appleAuthThunk.fulfilled, (state, action) => {
      state.inProgress = false
    })
    builder.addCase(appleAuthThunk.rejected, (state, action) => {
      state.inProgress = false
    })
    // getMe
    builder.addCase(getMeThunk.pending, (state, action) => {
      state.inProgress = true
      state.error = null
    })
    builder.addCase(getMeThunk.fulfilled, (state, action) => {
      state.inProgress = false
      const user = action.payload.data
      if (action.payload.data.projects.length) {
        user.agency_role = action.payload.data.projects[0].role
      }
      state.user = user
    })
    builder.addCase(getMeThunk.rejected, (state, action) => {
      state.inProgress = false
    })
    // forgotPassword
    builder.addCase(forgotPasswordThunk.pending, (state, action) => {
      state.inProgress = true
      state.error = null
    })
    builder.addCase(forgotPasswordThunk.fulfilled, (state, action) => {
      state.inProgress = false
    })
    builder.addCase(forgotPasswordThunk.rejected, (state, action) => {
      state.inProgress = false
    })
    // Check reset pass token token
    builder.addCase(checkTokenToUpdatePasswordThunk.pending, (state, action) => {
      state.inProgress = true
      state.error = null
    })
    builder.addCase(checkTokenToUpdatePasswordThunk.fulfilled, (state, action) => {
      state.inProgress = false
    })
    builder.addCase(checkTokenToUpdatePasswordThunk.rejected, (state, action) => {
      state.inProgress = false
    })
    // Check reset pass token token
    builder.addCase(updatePasswordThunk.pending, (state, action) => {
      state.inProgress = true
      state.error = null
    })
    builder.addCase(updatePasswordThunk.fulfilled, (state, action) => {
      state.inProgress = false
    })
    builder.addCase(updatePasswordThunk.rejected, (state, action) => {
      state.inProgress = false
    })
    // logOut
    builder.addCase(logOutThunk.pending, (state, action) => {
      state.inProgress = true
      state.error = null
    })
    builder.addCase(logOutThunk.fulfilled, (state, action) => {
      state.inProgress = false
    })
    builder.addCase(logOutThunk.rejected, (state, action) => {
      state.inProgress = false
    })
  }
})

export const { setUserAction, setUserRoleAction, appLogOutAction, setTokenAction, resetAuthErrorAction } =
  usersSlice.actions
export default usersSlice.reducer
